window.hambroHeaders = (function () {
    var $window = $(window),
        $stickies;

    var zeroTopValue = 0;

    var init = function (stickies, parent) {
        $window = parent;
        if (typeof stickies === "object" && stickies instanceof $ && stickies.length > 0) {

            var i = 0;
            $stickies = stickies.each(function () {

                var $thisSticky = $(this).wrap('<div class="followWrap" />');

                if (i === 0) {
                    zeroTopValue = parseFloat($thisSticky.parent().offset().top);
                }

                i++;

                $thisSticky
                    .data('originalHeight', $thisSticky.outerHeight())
                    .data('originalPosition', parseFloat($thisSticky.parent().offset().top - zeroTopValue))
                    .parent()
                    .height($thisSticky.outerHeight());

            });

            $window.off("scroll.stickies").on("scroll.stickies", function () {
                _whenScrolling();
            });

        }
    };

    var _whenScrolling = function () {
        $stickies.each(function (i) {

            var $thisSticky = $(this),
                $stickyPosition = $thisSticky.data('originalPosition');

            if ($stickyPosition <=  $window.scrollTop()) {

                var $nextSticky = $stickies.eq(i + 1),
                    $nextStickyPosition = $nextSticky.data('originalPosition') - $thisSticky.data('originalHeight');

                $thisSticky.addClass("fixed");

                if ($nextSticky.length > 0 && $thisSticky.offset().top >= $nextStickyPosition) {

                    $thisSticky.addClass("absolute").css("top", $nextStickyPosition);
                }

            } else {

                var $prevSticky = $stickies.eq(i - 1);

                $thisSticky.removeClass("fixed");

                if ($prevSticky.length > 0 && $window.scrollTop() <= $thisSticky.data('originalPosition') - $thisSticky.data('originalHeight')) {

                    $prevSticky.removeClass("absolute").removeAttr("style");
                }
            }
        });
    };

    return {
        init: init
    };
})();